import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import {useApi} from "../provider/ApiProvider";
import UserDialog from "../dialogs/UserDialog";
import {Badge, Button, Input, notification, Popconfirm, Select} from 'antd';
import {
    DeleteOutlined,
    DownloadOutlined,
    EditFilled,
    FileExcelOutlined,
    PlusOutlined,
    RightOutlined,
    SaveFilled
} from "@ant-design/icons";

import { Excel } from 'antd-table-saveas-excel';

const {Option} = Select
export default function FootTicketPage(){

    const columns = [

        {
            title: 'Adı',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Soyadı',
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: 'TC',
            dataIndex: 'identityNumber',
            key: 'identityNumber',

        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
            responsive: ["lg"]
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            responsive: ["lg"]
        },

        {
            title: 'Firma / Şube',
            render: (record) => record.Company.name
        },

        {
            title: 'Durumu',
            responsive: ["lg"],
            render: (record) => record.isActive ? <Badge status="success" text={"Aktif"} /> : <Badge status="error" text={"Pasif"} />

        },

        {
            title: 'Yemek Fişi (Adet)',
            fixed: 'right',
            width: 150,
            render: (record) => (
                <EditableComp onChange={() => search()} record={record} />
            )
        }

    ];
    const columnsexcel = [

        {
            title: 'Adı',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Soyadı',
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: 'TC',
            dataIndex: 'identityNumber',
            key: 'identityNumber',

        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
            key: 'phone',
            responsive: ["lg"]
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            responsive: ["lg"]
        },

        {
            title: 'Firma / Şube',
            dataIndex: ['Company','name'],
            key: 'Firma / Şube',
            responsive: ["lg"]

        },

        {
            title: 'Durumu',
            dataIndex: 'isActive',
            key: 'Durumu',
            responsive: ["lg"],
        }
    ];


    const {api} = useApi();
    const [users, setUsers] = useState({totalCount: 0, items: []});
    const [dialog, setDialog] = useState({open: false, data: null});
    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [filter, setFilter] = useState({search: "", isActive: true, skip: 0, max: 10000});

    useEffect(() => {
       load()
    }, [])

    async function load(){
        setLoading(true);
        await Promise.all([
            api.get('/companyRouter/company/all?skip=0&max=10000')
        ]).then(resp => {
            setCompanies(resp[0].data);
        }).finally(() => {
            setLoading(false);
        })

    }

    function onChangeFilter(key,value){
        console.log(key + '-' + value)
        setFilter({
            ...filter,
            [key]: value
        })
    }

    function addDialog(){
        setDialog({open: true, data: null});
    }

    function editDialog(data){
        setDialog({open: true, data: data});
    }

    async function onSearch(value){
        let filter = {
            search: value
        }
        await api.get('/userRouter/user/all', filter).then(resp => {
            setUsers({totalCount: resp.totalCount, items:resp.data});
        })
    }

    async function deleteRow(id){
        await api.delete('/userRouter/user/delete/' + id).then(resp => {
            load({search: "", skip: 0, max: 10})
        })
    }

    function tableChange(filter){
        let newFilter = {
            skip: (filter.page - 1) * filter.perPage,
            max: filter.perPage
        }
        load(newFilter);
    }

    async function search(){
        setLoading(true);
        await api.get('/userRouter/user/all', filter).then(resp => {
            setUsers({totalCount: resp.totalCount, items:resp.data});
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <LayoutComponent
            title={"Yemek Fişi Yönetimi"}
            subTitle='* Firma veya Kullanıcı TC Kimlik numarası ile filtreleme yapınız'

            links={
            [
                {
                    title: 'Yemek Fişi Yönetimi',
                    url: ''
                },
            ]
        } newButton={<>
            {/*<div>*/}
            {/*    <Button icon={<PlusOutlined />} onClick={() => addDialog()} type="primary" style={{marginRight: '10px'}}>Ekle</Button>*/}
            {/*    */}
            {/*    <Button*/}
            {/*        type="primary"*/}
            {/*        icon={<FileExcelOutlined />}*/}
            {/*        onClick={() => {*/}
            {/*            const excel = new Excel();*/}
            {/*            excel*/}
            {/*                .addSheet('Kullanıcılar')*/}
            {/*                .addColumns(columnsexcel)*/}
            {/*                .addDataSource(users.items)*/}
            {/*                .saveAs('Kullanıcılar.xlsx');*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        Excel*/}
            {/*    </Button>*/}
            {/*</div>*/}

        </>}>
            <div className="filter-box">
                <Select
                    showSearch
                    placeholder="Firma"
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    style={{width: '17rem'}}
                    allowClear={true}
                    onChange={value => onChangeFilter('companyId',value)}
                >
                    {companies.length > 0 && companies.map((item, idx) => (
                        <Option key={"company-" + idx} value={item.id}>{item.name}</Option>
                    ))}
                </Select>
                <Input onChange={e => onChangeFilter('identityNumber', e.target.value)} placeholder="TC Kimlik Numarası" style={{width: '17rem', marginLeft: '1rem'}} />
                <Button
                    onClick={search}
                    style={{marginLeft: '1rem'}}
                    type="primary"
                    disabled={!filter.identityNumber && !filter.companyId}
                >
                    Filtrele
                </Button>
            </div>
            <TableComponent
                loading={loading}
                columns={columns}
                data={users}
                search={false}
                onSearch={onSearch}
                onChange={tableChange}

            />
            <UserDialog
                open={dialog.open}
                data={dialog.data}
                onChange={() => load()}
                onClose={() => setDialog({open: false, data: null})}
            />
        </LayoutComponent>
    )
}

function EditableComp({record, onChange}){
    const {api} = useApi();

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const saveTicket = async () => {
        if(!data){
            notification.warning({message: 'Lütfen bir değer giriniz'})
        }else{
            setLoading(true);
            await api.post('/userRouter/user/save-ticket',{id: record.id, ticketCount: data}).then(resp => {
                onChange();
            }).finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        if(record.ticketCount){
            setData(record.ticketCount)
        }
    },[record.ticketCount])

    return (
        <div>
            <Input value={data} onChange={e => setData(e.target.value)} style={{width: '50%'}} />
            <Button disabled={loading} style={{width: '50%'}} onClick={saveTicket}>
                <SaveFilled style={{color: 'green'}} />
            </Button>
        </div>
    )
}
